module.exports = __webpack_public_path__ + "img/IND-i-2-I.f11930c5.png";